import Text from '@cartwhl/ui/base/Text';
import Button from '@cartwhl/ui/input/Button';
import Modal from '@cartwhl/ui/molecules/Modal';

export default function DeleteProjectModal({
  open,
  onOpenChange,
  onConfirm,
  projectCount,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  projectCount: number;
}) {
  const isMultiple = projectCount > 1;

  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      maxWidth={550}
      horizontalBleed={true}
      verticalBleed={true}
    >
      <div className="flex flex-col gap-4 px-5 pt-6 pb-6">
        <Text as="h2" variant="studio/title/xl">
          Delete {isMultiple ? `${projectCount} projects` : 'project'}?
        </Text>
        <Text variant="studio/body/md" className="text-secondary">
          Are you sure you want to delete{' '}
          {isMultiple ? 'these projects' : 'this project'}? This action cannot
          be undone.
        </Text>
        <div className="flex gap-3 pt-2">
          <Button
            variant="secondary"
            size="lg"
            onClick={() => onOpenChange(false)}
            className="flex-1"
          >
            Cancel
          </Button>
          <Button
            variant="primary-destructive"
            size="lg"
            onClick={() => {
              onConfirm();
              onOpenChange(false);
            }}
            className="flex-1"
          >
            Delete {isMultiple ? 'projects' : 'project'}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
